import {hasClickMenuTag, showRowMenu} from "../click-menu/click-menu";

/**
 * Loads data for the rows on the List page itself.
 */
export function loadListingRow() {
    const rows = document.querySelectorAll(".clickableRow");
    if (rows) {
        for (let i = 0; i < rows.length; i++) {
            const { menuId : menuIdVal, withCheckbox, displayFlags, rowId,
                optParam1, optParam2 } = rows[i].dataset;

            if (hasClickMenuTag()) {
                let menuId = menuIdVal ? menuIdVal : GlobalEnt.clickMenu.defaultMenuId;

                GlobalEnt.clickMenu.optParam1 = optParam1;
                GlobalEnt.clickMenu.optParam2 = optParam2;

                rows[i].addEventListener('click', function(evt) {
                    showRowMenu(evt, rows[i], menuId, displayFlags);
                    return false;
                });
            }

            if (withCheckbox) {
                const rowCheckbox = document.getElementById('clickable-row-cb-' + rowId);
                if (rowCheckbox) {
                    rowCheckbox.addEventListener('click', function(evt) {
                        GlobalEnt.listPageLogic.onRowToggle(rowId, evt);
                    });
                }
            }
        }
    }
}

export function hasListingRowTag() {
    return document.querySelector(".clickableRow");
}